import React, { useState } from 'react';
import { ArrowLeftIcon, MinusIcon, PlusIcon } from 'lucide-react';
import { DS } from '../ds';
import { AlinovaConstellation, GradientText } from '../Visuals';
import { Label, P } from '../Primitives';
const faqs = [{
  q: '¿Necesito experiencia previa en ortodoncia invisible?',
  a: 'No. Alinova está diseñado para acompañar al profesional en cada etapa, incluso si es su primer caso con alineadores. Nuestro equipo clínico te guía desde la planificación digital hasta la entrega, con soporte dedicado en todo el proceso.'
}, {
  q: '¿Cuánto tarda la fabricación de un caso?',
  a: 'El tiempo estándar de fabricación es de 7 a 10 días hábiles desde la aprobación del plan de tratamiento digital. Para casos con mayor complejidad o número de etapas, el tiempo puede extenderse ligeramente. Te informamos el plazo exacto antes de iniciar.'
}, {
  q: '¿Qué archivos necesito para enviar un caso?',
  a: 'Necesitas un escáner intraoral en formato STL o archivos de impresión de modelos físicos, más fotografías clínicas del paciente y radiografías panorámica y de perfil. Nuestro equipo te indica exactamente qué enviar según la modalidad que elijas.'
}, {
  q: '¿Puedo enviar un caso sin escáner intraoral?',
  a: 'escaner-aliados'
}, {
  q: '¿Cuál es el costo mínimo para empezar?',
  a: 'El costo depende de la modalidad y la complejidad del caso. La modalidad de Solo fabricación es la más accesible para clínicas que ya cuentan con flujo digital propio. Contáctanos y te enviamos una cotización personalizada sin compromiso.'
}, {
  q: '¿Alinova reemplaza al ortodoncista en la planificación?',
  a: 'No. Alinova es un aliado de fabricación y soporte tecnológico. El diagnóstico, la prescripción y la dirección clínica del tratamiento siempre son responsabilidad del profesional de la salud oral. Nosotros ejecutamos el plan que tú defines.'
}, {
  q: '¿Qué incluye el kit eco-premium?',
  a: 'Cada caso entregado incluye una caja kraft reciclada con logo impreso, una bolsa de tela lino bordada, un estuche bioplástico con espejo y una tarjeta de acceso digital con QR para seguimiento del caso, más un pequeño obsequio físico de marca.'
}, {
  q: '¿Tienen soporte durante el tratamiento?',
  a: 'Sí. Cada caso tiene un asesor asignado que acompaña el proceso desde el envío hasta la última etapa. Puedes consultarnos por WhatsApp o correo ante cualquier duda técnica, de ajuste o de seguimiento.'
}];
interface FAQSectionProps {
  onBack: () => void;
}
export function FAQSection({
  onBack
}: FAQSectionProps) {
  const [open, setOpen] = useState<number | null>(null);
  return <div id="faq" style={{
    minHeight: '100vh',
    background: DS.color.ivory,
    paddingTop: '88px'
  }} data-id="element-432" data-mp="u340p47rda46">
      <section aria-labelledby="faq-title" style={{
      background: `linear-gradient(160deg, ${DS.color.tealDeep} 0%, ${DS.color.ink} 100%)`,
      padding: '64px 24px 80px',
      position: 'relative',
      overflow: 'hidden'
    }} data-id="element-433" data-mp="29jupmk6bczan">
        <AlinovaConstellation width={400} height={400} opacity={0.07} rotation="counter" style={{
        position: 'absolute',
        top: '-100px',
        right: '-80px',
        pointerEvents: 'none'
      }} data-id="element-434" data-mp="2d3v7zgb5ze7u" />
        <AlinovaConstellation width={240} height={240} opacity={0.04} rotation="clockwise" style={{
        position: 'absolute',
        bottom: '-60px',
        left: '-40px',
        pointerEvents: 'none'
      }} data-id="element-435" data-mp="2825snogwsedy" />

        <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }} data-id="element-436" data-mp="30qtkk2w5y20h">
          <button type="button" onClick={onBack} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: DS.radius.pill,
          padding: '8px 18px',
          color: 'rgba(255,255,255,0.75)',
          fontFamily: DS.font.body,
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          marginBottom: '40px',
          transition: `all 0.2s ${DS.ease.smooth}`
        }} onMouseEnter={event => {
          event.currentTarget.style.background = 'rgba(255,255,255,0.14)';
          event.currentTarget.style.color = '#fff';
        }} onMouseLeave={event => {
          event.currentTarget.style.background = 'rgba(255,255,255,0.08)';
          event.currentTarget.style.color = 'rgba(255,255,255,0.75)';
        }} data-id="element-437" data-mp="2m1oxa7aih7li">
            <ArrowLeftIcon size={14} aria-hidden="true" data-id="element-438" data-mp="1zvw7gts830sf" />
            Volver al inicio
          </button>

          <Label light data-id="element-439" data-mp="2xbjvib8rv2ge">Preguntas frecuentes</Label>
          <h1 id="faq-title" style={{
          fontFamily: DS.font.heading,
          fontWeight: 700,
          fontSize: 'clamp(2.2rem, 5vw, 3.6rem)',
          color: '#fff',
          lineHeight: 1.1,
          letterSpacing: '-0.025em',
          margin: '12px 0 24px',
          maxWidth: '700px'
        }} data-id="element-440" data-mp="2xccyd14m17t9">
            Todo lo que necesitas <GradientText data-id="element-441" data-mp="3es77p1aa3rfa">saber antes de empezar.</GradientText>
          </h1>
          <P light size="lg" maxWidth="520px" data-id="element-442" data-mp="3eq4e679x3g5t">
            Si tienes más preguntas, nuestro equipo responde en menos de 24 horas hábiles por WhatsApp o correo.
          </P>
        </div>
      </section>

      <section aria-label="Preguntas y respuestas" style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '72px 24px 96px'
    }} data-id="element-443" data-mp="3nqixj13bml6o">
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
      }} data-id="element-444" data-mp="1du6epd3ba7g">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          const answerId = `faq-answer-${index}`;
          return <div key={faq.q} style={{
            borderRadius: '16px',
            background: isOpen ? DS.color.white : 'rgba(255,255,255,0.65)',
            border: `1.5px solid ${isOpen ? `${DS.color.aqua}55` : DS.color.border}`,
            boxShadow: isOpen ? DS.shadow.card : 'none',
            overflow: 'hidden',
            transition: `all 0.28s ${DS.ease.smooth}`
          }} data-id="element-445" data-mp="bc07j4r2ocb9" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={answerId} style={{
              width: '100%',
              textAlign: 'left',
              background: 'none',
              border: 'none',
              padding: '22px 24px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '16px'
            }} data-id="element-446" data-mp="4ct24ekn14dw">
                  <span style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '15px',
                color: isOpen ? DS.color.teal : DS.color.ink,
                lineHeight: 1.4,
                transition: `color 0.22s ${DS.ease.smooth}`
              }} data-id="element-447" data-mp="vl2wxm0taupk">
                    {faq.q}
                  </span>
                  <span aria-hidden="true" style={{
                flexShrink: 0,
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                background: isOpen ? DS.color.aqua : DS.color.mint,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: `all 0.22s ${DS.ease.smooth}`
              }} data-id="element-448" data-mp="byws1o91e3r3">
                    {isOpen ? <MinusIcon size={14} color={DS.color.tealDeep} strokeWidth={2.5} data-id="element-449" data-mp="g2rw0vczn9h4" /> : <PlusIcon size={14} color={DS.color.teal} strokeWidth={2.5} data-id="element-450" data-mp="b9f9qrvs7erj" />}
                  </span>
                </button>

                {isOpen && <div id={answerId} role="region" aria-label={`Respuesta: ${faq.q}`} className="anim-fade-in" style={{
              padding: '0 24px 22px',
              paddingRight: '24px'
            }} data-id="element-451" data-mp="1ex3beyzd541">
                    {faq.a === 'escaner-aliados' ? <div data-id="element-452" data-mp="1mqf0vk6e7njz">
                        <p style={{
                  fontFamily: DS.font.body,
                  fontSize: '14px',
                  color: DS.color.body,
                  lineHeight: 1.75,
                  margin: '0 0 24px'
                }} data-id="element-453" data-mp="1mpnft3af987y">
                          Sí. Si no cuentas con escáner intraoral, puedes acercarte a cualquiera de nuestros centros radiológicos aliados en Bogotá. Ellos realizan el escaneo y te envían los archivos listos para enviar tu caso.
                        </p>

                        {[{
                  brand: 'Oraltek',
                  color: DS.color.teal,
                  locations: [{
                    name: 'Chicó',
                    address: 'CR 11 # 96 - 43 Oficina S - 01'
                  }, {
                    name: 'Niza',
                    address: 'CRA 58 # 128B - 49'
                  }, {
                    name: 'Calle 45',
                    address: 'Av. Caracas # 44 - 13 Local 3'
                  }]
                }, {
                  brand: '3Dent',
                  color: '#08B8B3',
                  locations: [{
                    name: 'Calle 82',
                    address: 'Carrera 14 # 81 - 19 Oficina 601'
                  }, {
                    name: 'Calle 90',
                    address: 'Carrera 15 # 90 - 20 Local S114'
                  }, {
                    name: 'Calle 125',
                    address: 'Calle 125 # 21A - 18 Oficina 201'
                  }]
                }, {
                  brand: 'Nexdent',
                  color: '#4B9CD3',
                  locations: [{
                    name: 'Calle 120',
                    address: 'Calle 120 A 7 36 OF 1103'
                  }, {
                    name: 'Unicentro',
                    address: 'Cra. 15A #121 - 12 Of. 513-514'
                  }, {
                    name: 'Castellana',
                    address: 'Cl. 99 #49 - 38 Of. 703'
                  }, {
                    name: 'Calle 93',
                    address: 'Cra. 13 #93 - 85 Of. 301'
                  }]
                }].map(group => <div key={group.brand} style={{
                  marginBottom: '20px'
                }} data-id="element-454" data-mp="224mouonnlf77">
                            <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '10px'
                  }} data-id="element-455" data-mp="1xdoa3tibcp62">
                              <span aria-hidden="true" style={{
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      background: group.color,
                      flexShrink: 0
                    }} data-id="element-456" data-mp="1jctxszs5a424" />
                              <span style={{
                      fontFamily: DS.font.heading,
                      fontWeight: 700,
                      fontSize: '13px',
                      color: group.color,
                      letterSpacing: '0.06em',
                      textTransform: 'uppercase'
                    }} data-id="element-457" data-mp="33rx84hq9qxj7">
                                {group.brand}
                              </span>
                              <div aria-hidden="true" style={{
                      flex: 1,
                      height: '1px',
                      background: `${group.color}22`
                    }} data-id="element-458" data-mp="1ptn54pg7msqq" />
                            </div>

                            <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
                    gap: '8px'
                  }} data-id="element-459" data-mp="1fvfz31nglv3i">
                              {group.locations.map(location => <div key={location.name} style={{
                      padding: '12px 14px',
                      borderRadius: '10px',
                      background: `${group.color}08`,
                      border: `1px solid ${group.color}20`
                    }} data-id="element-460" data-mp="2dpqoa2m1uimt">
                                  <div style={{
                        fontFamily: DS.font.heading,
                        fontWeight: 700,
                        fontSize: '12px',
                        color: DS.color.ink,
                        marginBottom: '4px'
                      }} data-id="element-461" data-mp="1uwwavd42qykp">
                                    {location.name}
                                  </div>
                                  <div style={{
                        fontFamily: DS.font.body,
                        fontSize: '12px',
                        color: DS.color.body,
                        lineHeight: 1.5
                      }} data-id="element-462" data-mp="1tw1w34qqyezf">
                                    {location.address}
                                  </div>
                                </div>)}
                            </div>
                          </div>)}

                        <p style={{
                  fontFamily: DS.font.body,
                  fontSize: '12px',
                  color: 'rgba(0,0,0,0.4)',
                  marginTop: '16px',
                  fontStyle: 'italic'
                }} data-id="element-463" data-mp="2mjeinewwqmsq">
                          Todas las sedes están ubicadas en Bogotá, Colombia.
                        </p>
                      </div> : <p style={{
                fontFamily: DS.font.body,
                fontSize: '14px',
                color: DS.color.body,
                lineHeight: 1.75,
                margin: 0
              }} data-id="element-464" data-mp="5z2d5p8cqztc">
                        {faq.a}
                      </p>}
                  </div>}
              </div>;
        })}
        </div>

        <div style={{
        marginTop: '48px',
        textAlign: 'center',
        padding: '36px',
        borderRadius: '20px',
        background: DS.color.white,
        boxShadow: DS.shadow.card,
        border: `1px solid ${DS.color.border}`
      }} data-id="element-465" data-mp="3eem2we9te03n">
          <p style={{
          fontFamily: DS.font.body,
          fontSize: '15px',
          color: DS.color.body,
          marginBottom: '20px',
          lineHeight: 1.6
        }} data-id="element-466" data-mp="25i78isppyeze">
            ¿Tienes una pregunta que no está aquí?
          </p>
          <a href={DS.wa} target="_blank" rel="noopener noreferrer" style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '9px',
          padding: '12px 28px',
          borderRadius: DS.radius.pill,
          background: DS.color.tealDeep,
          color: '#fff',
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          textDecoration: 'none',
          transition: `all 0.22s ${DS.ease.smooth}`
        }} onMouseEnter={event => {
          event.currentTarget.style.background = DS.color.teal;
          event.currentTarget.style.transform = 'translateY(-1px)';
        }} onMouseLeave={event => {
          event.currentTarget.style.background = DS.color.tealDeep;
          event.currentTarget.style.transform = 'translateY(0)';
        }} data-id="element-467" data-mp="1hs31ebdbnx3n">
            <svg width="16" height="16" viewBox="0 0 32 32" fill="none" aria-hidden="true" data-id="element-468" data-mp="1354bwly0zcrk">
              <path d="M16 3C9.373 3 4 8.373 4 15c0 2.385.668 4.61 1.832 6.505L4 29l7.697-1.807A11.94 11.94 0 0016 27c6.627 0 12-5.373 12-12S22.627 3 16 3z" fill="#fff" data-id="element-469" data-mp="z4kintgkotap" />
            </svg>
            Escribir por WhatsApp
          </a>
        </div>
      </section>
    </div>;
}